
function updateScroll(container,value){
  console.log("Height: ",container.height(),"Prev Scroll: ",container.scrollTop(),"New Value: ",value);
  container.scrollTop(value);
}
 $(document).on("click", ".down_arrow_new", function() {
    var Thumbscontainer = $('.product-pistols .product-gallery .product-gallery__thumbnails_wrap .parent_thumb');
    if (!Thumbscontainer.length) return;
    var singleThumbHeight = Thumbscontainer.find('.product-gallery__thumbnail').first().outerHeight(true);
    var scrollDistance = 1.2 * singleThumbHeight;
    var newScroll = Math.ceil(Thumbscontainer.scrollTop() + scrollDistance);
    Thumbscontainer.scrollTop(newScroll);
    //setTimeout(updateScroll(Thumbscontainer,newScroll),100);
});

$(document).on("click", ".up_arrow_new", function() {  
    var Thumbscontainer = $('.product-pistols .product-gallery .product-gallery__thumbnails_wrap .parent_thumb');
    if (!Thumbscontainer.length) return;
    var singleThumbHeight = Thumbscontainer.find('.product-gallery__thumbnail').first().outerHeight(true);
    var scrollDistance = 1.2 * singleThumbHeight;
    var newScroll = Math.ceil(Math.max(Thumbscontainer.scrollTop() - scrollDistance, 0));
    Thumbscontainer.scrollTop(newScroll);
    //setTimeout(updateScroll(Thumbscontainer,newScroll),100);

});
